export const EMAIL_AUTOMATION_FIELDS = `
  id
  name
  description
  templateId
  templateName
  isActive
  triggerKind
  triggerEvent
  triggerDateProperty
  timingDirection
  offsetMinutes
  conditionGroups {
    conditions {
      property
      operator
      values
    }
  }
  activeSince
  createdAt
  updatedAt
`;

export const EMAIL_AUTOMATION_SEND_FIELDS = `
  id
  automationId
  objectId
  scheduledFor
  status
  skipReason
  missingVariables
  recipient
  sentAt
  updatedAt
`;
